import React from "react";
import PropTypes from "prop-types";
class AuthLayout extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div
        className="page-wrapper"
        ref={divElement => {
          this.divElement = divElement;
        }}
      >
        <div className="login-content"> {this.props.children}</div>
      </div>
    );
  }
}

AuthLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AuthLayout;
